import { RootState } from "@/store/store";
import { gridResourceDataSelector } from "@/store/resources-grid/selectors/resource-data/gridResourceDataSelector";

export const gridResourcesFilteredCountSelector = (
  state: RootState,
  masterGridId: string,
): number | undefined => {
  const data = gridResourceDataSelector(state, masterGridId);

  return data?.filtered_resources_count;
};
